module.exports = __webpack_public_path__ + "static/media/icore_tech_small.33809a6c.png";